/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceAction,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the DataExport HTTP resource (factory product). */
export class DataExportResource {
}

export function createDataExportResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const DataExport = createAdnHttpResource(send, 'dataexports', () => localUserProfile, 'dataExport');
  DataExport.copy = createAdnHttpResourceAction(send, {
    method: 'POST',
    url: ApiConfig.obtain().getVersionedUri('dataexports') + '/:id/copy',
    queryParams: ['dataExportId', 'name', 'description']
  });

  DataExport.copyDataExport = function(dataExport: any, newId: any) {
    if (!dataExport || !dataExport.id) {
      return Promise.reject('Insufficient parameters for the data export copy');
    }
    return DataExport.copy({
      id: dataExport.id,
      dataExportId: newId || '',
      name: dataExport.name,
      description: dataExport.description
    });
  };

  return DataExport;
}

export const dataExportResourceProvider = {
  provide: DataExportResource,
  useFactory: createDataExportResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

